const normalized = (message: unknown) => String(message || "").toLowerCase();

export function isPhysicsCapabilityUnavailableError(message: unknown): boolean {
  const text = normalized(message);
  return (
    text.includes("sharedarraybuffer") ||
    text.includes("cross-origin isolated") ||
    (text.includes("webassembly") && text.includes("mujoco"))
  );
}

function investigationMessage(): string {
  return "Copy the bug report and send feedback";
}

export function physicsErrorTitle(message: unknown): string {
  if (isPhysicsCapabilityUnavailableError(message)) {
    return "Physics is not available in this browser session";
  }
  const text = normalized(message);
  if (
    text.includes("timeout") ||
    text.includes("did not respond") ||
    text.includes("no response")
  ) {
    return "Physics took too long to start";
  }
  if (text.includes("stalled") || text.includes("no simulation progress")) {
    return "Physics stopped responding";
  }
  if (
    text.includes("xml") ||
    text.includes("parse") ||
    text.includes("compile") ||
    text.includes("model failed") ||
    text.includes("invalid mujoco model")
  ) {
    return "Model failed to load";
  }
  return "Physics failed";
}

export function physicsUserActionMessage(message: unknown): string {
  if (isPhysicsCapabilityUnavailableError(message)) {
    return "Try the latest Safari, Chrome, Edge, or Firefox for physics.";
  }
  const text = normalized(message);
  if (text.includes("unsafe-eval") || text.includes("content security policy")) {
    return investigationMessage();
  }
  if (
    text.includes("timeout") ||
    text.includes("did not respond") ||
    text.includes("no response")
  ) {
    return investigationMessage();
  }
  if (text.includes("stalled") || text.includes("no simulation progress")) {
    return investigationMessage();
  }
  if (text.includes("could not be deserialized") || text.includes("message could not be read")) {
    return investigationMessage();
  }
  if (
    text.includes("xml") ||
    text.includes("parse") ||
    text.includes("compile") ||
    text.includes("model failed") ||
    text.includes("invalid mujoco model")
  ) {
    return "This model could not be loaded for physics. If the file looks correct, copy the bug report and send feedback";
  }
  return investigationMessage();
}

export function physicsUserErrorToast(message: unknown): string {
  return `${physicsErrorTitle(message)}. ${physicsUserActionMessage(message)}`;
}
